import React from 'react'
import PropTypes from 'propTypes'

import BareBonesNavbar from '../BareBonesNavbar'
import Container from '../Container'
import Body from '../Body'

import styles from './styles'

const SceneLayout = ({ children }) => (
  <>
    <BareBonesNavbar />
    <Body>
      <Container className={styles.container}>{children}</Container>
    </Body>
  </>
)

SceneLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default SceneLayout
